export default __webpack_public_path__ + "static/media/ic_mlp_24.168706ea.svg";